import { connect } from 'react-redux';

import { selectIsOfferWithMultiAds } from '../../selectors';
import { getIsNewMultiAddsEnabled } from '../../selectors/featureToggle';
import { IState } from '../../store/index';
import { isCountrysideCardIntegrated } from '../../utils/countrysideCardIntegration';
import { IOfferTitleProps, OfferTitle } from './index';
export function mapStateToProps(state: IState): IOfferTitleProps {
  return {
    businessShoppingCenter: state.offerData.businessShoppingCenter,
    offer: state.offerData.offer,
    isCountrysideCardIntegrated: isCountrysideCardIntegrated(state),
    agent: state.offerData.agent,
    kp: state.offerData.kp,
    /**
     * @todo Удалить строку с RS
     * @description Данный функционал появился в задаче CD-150860, будет удалён в задаче CD-151061
     */
    isCommercialMultiAdsEnabled: getIsNewMultiAddsEnabled(state),
    isCommercialOfferWithMultiAds: selectIsOfferWithMultiAds(state),
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OfferTitleContainer = connect<IOfferTitleProps, any, any>(mapStateToProps)(OfferTitle);
